// extracted by mini-css-extract-plugin
export default {"menu":"lb","button":"mb","buttonIcon":"nb","list":"ob","buttonActive":"pb","listWrapper":"qb"};